import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  enh_action: 'promo_click',
  event_name: 'navigation_click',
  event_category: 'global',
  event_action: 'navigation click',
  event_label: [], // '<promo_pos> - <promo_creative> - <navigation name> - <navigation link>'
  promo_pos: ['gnav'],
  promo_creative: ['link'],
  promo_name: [], // '<navigation name> - <navigation link>'
  promo_id: [], // '<promo_pos> - <promo_creative> - <navigation name> - <navigation link>'
};

function trackNavigationClick(_: string, eventData: IDataLayer = {}) {
  if (eventData?.promo_name) {
    let promo_position = defaultData.promo_pos[0];

    if (eventData.promo_pos && eventData.promo_pos.length === 1) {
      promo_position = eventData.promo_pos[0] || promo_position;
    }

    eventData.promo_name = [
      eventData.promo_name.indexOf('>') === 0
        ? eventData.promo_name.replace(/[>]+/, '').toLowerCase()
        : eventData.promo_name.toLowerCase(),
    ];
    eventData.event_label = [
      promo_position + '-' + 'link' + '-' + eventData.promo_name,
    ];
    eventData.promo_id = [
      promo_position + '-' + 'link' + '-' + eventData.promo_name,
    ];
    eventData.promo_pos = [promo_position];

    tealium.evtLink({ ...defaultData, ...eventData });
  }
}

registerAnalyticsEventHandler('navigationClick', trackNavigationClick);
